import React, { Component } from "react"
import PropTypes from "prop-types"
import Spinner from "react-spinkit"

class ProgressOverlay extends Component {
  render() {
    return (
      <div className={`progress-overlay-wrapper ${ this.props.visible ? "" : "m_hide" }`}>
        <div className="progress-overlay-container">
          { this.props.children }
          <div className="spinner-container">
            <Spinner name="double-bounce" color="white" fadeIn="none" />
          </div>
        </div>
      </div>
    )
  }
}

ProgressOverlay.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.node
}

export default ProgressOverlay



// WEBPACK FOOTER //
// ./src/components/ProgressOverlay/index.js